module.exports = __webpack_public_path__ + "static/media/Niveau_elN5_1_847480.58cf31ae.png";